import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { Form, FormMessage, HintView, MainView } from "lib/index";
import { stateSelector, updateProduct, validate } from "../index";
import { initializeView } from "./index";
import ProductVariantsListing from "../ProductVariantsListing";
import ProductVariantFormSection from "./ProductVariantFormSection";
import Hint from "./StepAccommodationSettingsHint";

@connect(
  (state) => ({
    initialProduct: stateSelector(state).initialProduct,
    product: stateSelector(state).product,
    valid: stateSelector(state).valid,
    errors: stateSelector(state).errors,
    submitLoading: stateSelector(state).submitLoading,
    fetchDone:
      stateSelector(state).StepAccommodationSettings &&
      stateSelector(state).StepAccommodationSettings.facilities &&
      stateSelector(state).StepAccommodationSettings.facilities.fetchDone,
    facilities:
      stateSelector(state).StepAccommodationSettings &&
      stateSelector(state).StepAccommodationSettings.facilities &&
      stateSelector(state).StepAccommodationSettings.facilities.model,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        updateProduct,
        validate,
      },
      dispatch
    )
)
export default class StepAccommodationSettingsForm extends React.PureComponent {
  componentDidMount() {
    this.props.initializeView();
  }

  handleProductVariantChange(nextProductVariant) {
    const { product, updateProduct } = this.props;
    updateProduct({
      ...product,
      product_variants: product.product_variants.map((pv) =>
        pv.uuid === nextProductVariant.uuid ? nextProductVariant : pv
      ),
    });
  }

  render() {
    const { product, valid, errors, validate, submitLoading, readOnlyAccess, fetchDone, facilities } = this.props;

    if (!fetchDone) {
      return <MainView.Dimmer loading />;
    }

    return (
      <HintView.Container>
        <HintView.Content>
          <Form className="text" error={!valid} loading={submitLoading}>
            <h1>{I18n.t("papp.products.EditProductView.StepAccommodationSettings.form_title")}</h1>
            {!!errors.base && <FormMessage error={errors.base} />}
            <ProductVariantsListing
              product={product}
              renderProductVariant={(pv) => (
                <ProductVariantFormSection
                  name={`product.product_variants[${pv.uuid}]`}
                  errors={errors}
                  product_variant={pv}
                  product_price_currency={product.price_currency}
                  onChange={this.handleProductVariantChange.bind(this)}
                  onBlur={validate}
                  readOnlyAccess={readOnlyAccess}
                  facilities={facilities}
                />
              )}
            />
          </Form>
        </HintView.Content>
        <HintView.Sidebar>
          <Hint />
        </HintView.Sidebar>
      </HintView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepAccommodationSettings/StepAccommodationSettingsForm.jsx